import { render } from "./AssignmentModal.vue?vue&type=template&id=f8eedfc2&scoped=true"
import script from "./AssignmentModal.vue?vue&type=script&lang=js"
export * from "./AssignmentModal.vue?vue&type=script&lang=js"

import "./AssignmentModal.vue?vue&type=style&index=0&id=f8eedfc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8eedfc2"]])

export default __exports__